import "./style/main.css";

import type { FC } from "react";
import { Slide, ToastContainer, type ToastContainerProps } from "react-toastify";

type NotificationContainerProps = Pick<ToastContainerProps, "autoClose" | "containerId" | "limit" | "position">;

export const NotificationContainer: FC<NotificationContainerProps> = (props) => (
  <ToastContainer
    containerId={props.containerId}
    position={props.position ?? "bottom-right"}
    toastStyle={{ zIndex: 9_999_999 }}
    style={{ zIndex: 99_999_999 }}
    bodyStyle={{ zIndex: 99_999_999 }}
    hideProgressBar={false} // because a bug: https://github.com/fkhadra/react-toastify/issues/822
    pauseOnFocusLoss={true}
    pauseOnHover={true}
    draggable={false}
    newestOnTop
    closeButton={false}
    closeOnClick={false}
    transition={Slide}
    limit={props.limit ?? 5}
  />
);
